import {
    Component,
    Input,
    OnChanges,
    OnInit,
    ChangeDetectionStrategy
} from "@angular/core";
import { InputComponent } from "@components/input/input.component";
import { TableComponent } from "@components/table/table.component";
import { RaskColumn } from "~app/common/components/table/models/rask-column";
import { Viol3formatService } from "~app/features/shared/services/viol3format.service";
import {
    IOrderConfirmationLineItemPreviewData,
    IViol3DeliverySourcePreviewData,
    IViol3LoadtenderPreviewData,
    IViol3ServiceInstructionLinePreviewData
} from "../viol3-preview.model";

@Component({
    selector: "rask-viol3-avtalsobjekt",
    templateUrl: "./viol3-avtalsobjekt.component.html",
    styleUrls: ["./viol3-avtalsobjekt.component.scss"],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [
        InputComponent,
        TableComponent
    ]
})
export class Viol3AvtalsobjektComponent implements OnInit, OnChanges {
    @Input() data: IViol3DeliverySourcePreviewData[];
    @Input() requestedAvtalsobjekt: string;

    selectedAvtalsobjekt: IViol3DeliverySourcePreviewData;
    get avlagg() {
        return this.selectedAvtalsobjekt?.supplyPoints?.map(s => s.easting && s.northing ? `${Math.round(s.easting)} ${Math.round(s.northing)} ` : "");
    }

    get serviceInstructionLines() {
        return this.selectedAvtalsobjekt?.forestLoggingInstructions?.reduce((item, lines) => lines.serviceIntructionLines, []) ?? [];
    }

    get loadtenders() {
        return this.selectedAvtalsobjekt?.orderConfirmation?.loadtenders ?? [];
    }

    orderConfirmationtableColumns = [
        {
            headerName: "Nummer",
            field: "lineItemNumber",
            readonly: true,
            type: "span",
            maxWidth: 90,
            resizable: true
        },
        {
            headerName: "Inmätt hs",
            field: "productIdentifier",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true,
            tooltipGenerator: (row: IOrderConfirmationLineItemPreviewData, value: string) => row.productName
        },
        {
            headerName: "Mottagningsplats",
            field: "shipTo",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true,
            tooltipGenerator: (row: IOrderConfirmationLineItemPreviewData, value: string) => row.shipToName
        },
        {
            headerName: "Producerat hs",
            field: "productIdentifierProduced",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true,
            tooltipGenerator: (row: IOrderConfirmationLineItemPreviewData, value: string) => row.productProducedName
        },
        {
            headerName: "Redovisningshänvisning",
            field: "compensationChainNumber",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true,
            tooltipGenerator: (row: IOrderConfirmationLineItemPreviewData, value: string) =>
                Viol3formatService.formatRedovisninghanvisningTooltip(row.destineringsraderDto)
        },
        {
            headerName: "From",
            field: "acceptedDateRangeStart",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        },
        {
            headerName: "Tom",
            field: "acceptedDateRangeEnd",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        }
    ] as RaskColumn[];

    loadtenderColumns =  [
        {
            headerName: "Dokumentnummer",
            field: "documentNumber",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        },
        {
            headerName: "Inmätt hs",
            field: "productIdentifier",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true,
            tooltipGenerator: (row: IViol3LoadtenderPreviewData, value: string) => row.productName
        },
        {
            headerName: "Mottagningsplats",
            field: "placeFinalDestination",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true,
            tooltipGenerator: (row: IViol3LoadtenderPreviewData, value: string) => row.placeFinalDestinationName
        },
        {
            headerName: "Planerad start",
            field: "plannedStartDate",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        },
        {
            headerName: "Planerad slut",
            field: "plannedEndDate",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        },
        {
            headerName: "Ansvarigt transportföretag",
            field: "logsticsSupplier.assignedByAgency",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        },
        {
            headerName: "Avstånd enl. kvv BK1",
            field: "roadCharacteristicsBK1",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        },
        {
            headerName: "Avstånd enl. kvv BK4",
            field: "roadCharacteristicsBK4",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true
        }
    ] as RaskColumn[];

    serviceIntructionColums =  [
        {
            headerName: "Nummer",
            field: "lineItemNumber",
            readonly: true,
            type: "span",
            maxWidth: 90,
            resizable: true
        },
        {
            headerName: "Producerat HS",
            field: "productIdentifier",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true,
            tooltipGenerator: (row: IViol3ServiceInstructionLinePreviewData, value: string) => row.productName
        },
        {
            headerName: "Mottagningsplats",
            field: "placeFinalDestination",
            readonly: true,
            type: "span",
            minWidth: 90,
            resizable: true,
            tooltipGenerator: (row: IViol3ServiceInstructionLinePreviewData, value: string) => row.placeFinalDestinationName
        },
        {
            headerName: "Status",
            field: "status",
            readonly: true,
            type: "span",
            maxWidth: 120,
            resizable: true
        }
    ] as RaskColumn[];

    ngOnInit(): void {
        this.selectedAvtalsobjekt = this.data[0];
    }

    ngOnChanges(): void {
        this.selectedAvtalsobjekt = this.data[0];
    }
}
